var render = function render(){var _vm=this,_c=_vm._self._c;return _c('edit-order-collection-input-container',{attrs:{"inputLines":_vm.inputLines}})
}
var staticRenderFns = []

export { render, staticRenderFns }